/**
 * Hostadmin mode (KI-REM-001 item 4).
 *
 * A Hostadmin opens KI with "?hostadmin=1&tenant_id=<agency tenant>". The URL no longer carries
 * a shared secret: the server grants Hostadmin only from the Hostadmin role on the portal app
 * in the Outlook Insight tenant. The tenant header is sent only in Hostadmin mode, because its
 * presence is what tells the server to validate the caller against the portal app.
 */
export function getHostadminHeaders(): Record<string, string> {
    const params = new URLSearchParams(window.location.search);
    const tenantId = params.get('tenant_id');

    if (params.has('hostadmin') && tenantId) {
        return { 'x-hostadmin-tenant-id': tenantId };
    }
    return {};
}
